import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import AutoScroll from "embla-carousel-auto-scroll";

const HeroSection = () => {
  const plugin = React.useRef(
    AutoScroll({
      speed: 1.5,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    })
  );

  const services = [
    { id: 'consultancy', name: 'Consultancy', image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=150&h=150&fit=crop' },
    { id: 'furniture-design', name: 'Furniture Design', image: 'https://images.unsplash.com/photo-1592078615290-033ee584e267?w=150&h=150&fit=crop' },
    { id: 'supervising', name: 'Supervising', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=150&h=150&fit=crop' },
    { id: 'space-planning', name: 'Space Planning', image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=150&h=150&fit=crop' },
    { id: 'site-execution', name: 'Site Execution', image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=150&h=150&fit=crop' },
    { id: 'civil-planning', name: 'Civil Planning', image: 'https://images.unsplash.com/photo-1581094794329-cd1096a7a5ea?w=150&h=150&fit=crop' },
    { id: 'consultancy', name: 'Consultancy', image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=150&h=150&fit=crop' },
  ];

  return (
    <section className="relative pt-4 bg-gradient-to-r from-[#ffffff] via-[#e8f5e9] to-[#c8e6c9] overflow-hidden">
      {/* Services Icons Row */}
      <div className="py-8 border-b border-gray-300">
        <div className="max-w-7xl mx-auto px-4">
          <Carousel
            plugins={[plugin.current]}
            className="w-full"
            opts={{
              align: "start",
              loop: true,
              dragFree: true,
            }}
          >
            <CarouselContent className="-ml-4">
              {services.map((service, index) => (
                <CarouselItem key={index} className="pl-4 basis-2/2 md:basis-1/3 lg:basis-1/6">
                  <Link to={`/services/${service.id}`} className="block h-full">
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.1 }}
                      className="flex flex-col items-center text-center group cursor-pointer h-full justify-center"
                    >
                      <div className="w-20 h-20 rounded-full bg-white shadow-md flex items-center justify-center mb-3 group-hover:shadow-lg transition-all duration-300 group-hover:scale-105 overflow-hidden">
                        <img
                          src={service.image}
                          alt={service.name}
                          className="w-full h-full object-cover rounded-full"
                        />
                      </div>
                      <span className="text-sm font-medium text-gray-800 group-hover:text-[#008000] transition-colors duration-300">{service.name}</span>
                    </motion.div>
                  </Link>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>

      {/* Main Hero Content */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            {/*   <div className="inline-block">
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg">
                  <div className="text-center">
                    <div className="text-sm font-bold text-gray-800 leading-none">RB</div>
                    <div className="text-[8px] text-gray-600 leading-none mt-1">RAIPUR BUILDER</div>
                  </div>
                </div>
              </div>
            </div> */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Transforming Spaces with FCV Constructions
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed">
              Expert Architecture and Interior Design Services – Combining Creativity, Functionality, and Sustainability
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="https://wa.me/919039200574"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3 bg-[#008000] text-white font-semibold rounded-md hover:bg-[#006400] transition-all duration-300 shadow-md hover:shadow-lg inline-flex items-center justify-center"
              >
                Get Started
              </a>
              <Link
                to="/projects"
                className="px-8 py-3 bg-white text-gray-800 font-semibold rounded-md hover:bg-gray-50 transition-all duration-300 shadow-md hover:shadow-lg inline-flex items-center justify-center"
              >
                View Projects
              </Link>
            </div>
          </motion.div>

          {/* Right Content - Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80"
                alt="Construction Architecture"
                className="w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;